// extracted by mini-css-extract-plugin
export default {"imageContent":"Om-z","modal":"Pm-z"};